import { JoonUIColor } from "@joonapp/web-shared"
import { useEffect, useRef } from "react"

import AddFamilyMemberModal from "./AddFamilyMemberModal"
import FamilyUserSelectHeader from "./FamilyUserSelectHeader"
import PageWrapper from "../../components/pageWrapper/PageWrapper"
import useDocumentTitle from "../../hooks/useDocumentTitle"
import { usePageWrapperScroll } from "../../hooks/usePageWrapperScroll"
import { useFamilyQuery } from "../../networking/queries"
import { requireAuth } from "../../util/auth"
import FamilyUserPage from "../familyUser/FamilyUserPage"

const FamilyPage = () => {
  useDocumentTitle("Joon - Family")
  const pageWrapperRef = useRef<HTMLDivElement>(null)
  const { setPageWrapperRef } = usePageWrapperScroll()

  // Setting a ref so we can tell if page is scrolled in other components
  useEffect(() => {
    setPageWrapperRef(pageWrapperRef)
  }, [setPageWrapperRef])

  const { data: family } = useFamilyQuery()

  if (!family) return null

  return (
    <PageWrapper
      ref={pageWrapperRef}
      style={{ background: JoonUIColor.background.xlightGray }}
    >
      <FamilyUserSelectHeader />
      <FamilyUserPage />
      <AddFamilyMemberModal />
    </PageWrapper>
  )
}

const FamilyPageWithAuth = requireAuth(FamilyPage)
export default FamilyPageWithAuth
